import { render } from "./CartButton.vue?vue&type=template&id=5966e5b4"
import script from "./CartButton.vue?vue&type=script&lang=js"
export * from "./CartButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/app/components/CartButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5966e5b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5966e5b4', __exports__)) {
    api.reload('5966e5b4', __exports__)
  }
  
  module.hot.accept("./CartButton.vue?vue&type=template&id=5966e5b4", () => {
    api.rerender('5966e5b4', render)
  })

}


export default __exports__